module.exports = __webpack_public_path__ + "static/media/EzioAuditore.f6c09c02.png";